export const ROOM_TYPES = {
  LivingRoom: 1,
  Kitchen: 2,
  WorkingRoom: 3,
  Bedroom: 4,
  Corridor: 5,
  Central: 6,
  Bathroom: 7,
  Toilet: 8,
  Garage: 9,
  ETC: 10,
  TerraceOrBalcony: 11,
  Garden: 12,
};

export const ALGO_TYPES = {
  Lighting: 'lighting',
  Count: 'count',
  Wall: 'wall',
  Coverage: 'coverage',
  Door: 'door',
  Window: 'window',
  WallModOut: 'wallmodout',
  OuterDoor: 'outerdoor',
  Server: 'server',
  Ventilator: 'ventilator',
  Serial: 'serial'
};

export const LOX_LIGHT_CATEG_ID = 9;
export const LOX_SHADING_CATEG_ID = 10;
export const CONV_LIGHT_CATEG_ID = 17;
export const CONV_SHADING_CATEG_ID = 18;
export const CONV_LIGHT_SWITCH_IDS = [16, 17, 18, 19, 20, 368];
export const CONV_SHADING_SWITCH_IDS = [322, 323];